import { FeedbackShowResource, Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";

const eventFeedbackKey = (eventId: Id) => ["events", `${eventId}`, "feedback"];

export const eventFeedbackService = {
	eventFeedbackKey,
	eventFeedback: (eventId: Id) =>
		axios.get<LaravelResponse<FeedbackShowResource[]>>(keyToUrl(eventFeedbackKey(eventId))),
};
